import { ParentProperty } from './../../base-models/parent-property';
import { BehaviorSubject } from 'rxjs';
import { Focusable } from './../../interfaces/focusable';
import { DropDownControlButtonsComponent } from './dropdown-buttons/drop-down-control-buttons.component';
import { ModelDataService } from './../../base-services/model-data.service';
import { BaseEntity } from './../../base-models/base-entity';
import { ModalService } from './../../base-services/modal.service';
import { CollectionService } from './../../base-services/collection.service';
import { BaseDataService } from './../../base-services/base-data.service';
import { OnInit, OnDestroy, Input, ViewChild, ElementRef, ChangeDetectorRef, SimpleChanges } from "@angular/core";
import { Subscription } from 'rxjs';
import { ModelData } from '../../base-models/model-data';
import { AbstractCustomControl } from '../abstract-custom-control';
import { QueryParameter } from '../../base-models/query-parameter';
import { Observable } from 'rxjs';
import { List } from 'immutable';
import { MultiSelectComponent } from 'ng-multiselect-dropdown';

export class BaseDropdown<T extends BaseEntity> 
    extends AbstractCustomControl<any> 
    implements OnInit, OnDestroy, Focusable{
    constructor(
        protected baseDataService: BaseDataService,
        public collectionService: CollectionService,
        protected modalService: ModalService,
        protected modelDataService: ModelDataService,
        protected changeDetectorRef: ChangeDetectorRef
    ){
        super(changeDetectorRef);
    }

    Items: List<T>;

    private _itemsSubscription: Subscription;
    public _modelData: ModelData;
    itemsLoading: boolean = false;
    private itemsSubject = new BehaviorSubject<number>(0);
    itemsLoadedObservable = this.itemsSubject.asObservable();
    private getParameters: QueryParameter[];
    private wasGetParametersDefined = false;

    private pendingGetParameters: List<QueryParameter> | null = null;
    private isModelDataReady: boolean = false;

    @Input() ModelName: string;
    @Input() GetName: string;
    @Input() Parameters: QueryParameter[];
    @Input() set GetParameters(value: List<QueryParameter>){
if (Array.isArray(value) && value.length > 0) {
    // console.log('Stigao običan niz:', value);
    
    let convertedList: List<QueryParameter> = List([]);

    value.forEach((item, index) => {
        const param = new QueryParameter();
        param.Name = item.Name;
        param.Value = item.Value;

        convertedList = convertedList.push(param);

    });

        value = convertedList;
    }
        // this.getParameters = [];
        // if(value != null){
        //     value.forEach(parameter => {
        //         if(this.getParameters == null)
        //             this.getParameters = [];
        //         let queryParameter = new QueryParameter();
        //         queryParameter.Name = parameter.Name;
        //         queryParameter.Value = parameter.Value;
        //         this.getParameters.push(queryParameter);
        //         //this.getParameters = value;
        //     })
        // }
        // if(value != null && value.size > 0 && this._modelData != null){
        //     this.loadItems();
        // }
            this.wasGetParametersDefined = true;

        if (!this.isModelDataReady) {
            this.pendingGetParameters = value;
            return;
        }

        this.setGetParametersInternal(value);
    }

    private setGetParametersInternal(value: List<QueryParameter>) {
    this.getParameters = [];

    if (value != null) {
        value.forEach(parameter => {
            const queryParameter = new QueryParameter();
            queryParameter.Name = parameter.Name;
            queryParameter.Value = parameter.Value;
            this.getParameters.push(queryParameter);
        });
    }

    if (value != null && value.size > 0 && this._modelData != null) {
        this.loadItems();
    }
}
    @Input() ModelProperty: string;
    @Input() OrderBy: string;
    @Input() AllowAddNew: boolean;
    @Input() Required: boolean;
    //@Input() ModelClass: any;
    @Input() set Source(value: T[]){
        this.Items = List(value);
    };
    @Input() set Disabled(value: boolean){
        this.setDisabledState(value);
    }
    @Input() Type: string = 'item';
    //@Input() Placeholder: string;
    @Input() AllowEdit: boolean;
    @Input() ParentProperty: ParentProperty = null;
    @Input() RouteName: string;

    @ViewChild('select', /* TODO: add static flag */ {static: true}) selectControl: ElementRef;
    @ViewChild('dropDownControlButtons', /* TODO: add static flag */ {static: true}) dropDownControlButtons: DropDownControlButtonsComponent
    @ViewChild('placeholder', /* TODO: add static flag */ {static: true}) placeholder: ElementRef;
    @ViewChild('errorIcon', /* TODO: add static flag */ {static: true}) errorIcon: ElementRef;
    @ViewChild('multiSelect', /* TODO: add static flag */ {static: true}) multiSelect: MultiSelectComponent;

    //ngValueString: string = 'ID';

    ngOnInit(){
        this._modelData = this.modelDataService.GetModelDataByPath(this.RouteName && this.RouteName.length > 0 ? this.RouteName : this.ModelName);

        this.isModelDataReady = true;
        
    if (this.pendingGetParameters) {
        this.setGetParametersInternal(this.pendingGetParameters);
        this.pendingGetParameters = null;
    } else if (this.wasGetParametersDefined === false) {
        this.loadItems();
    }
        
    }

    ngOnChanges(changes: SimpleChanges){
        if (changes['GetParameters']) {
            this.wasGetParametersDefined = true;
            // console.log('GetParameters definisan u parent komponenti');
        }
    }

    ngOnDestroy(){
        if(this._itemsSubscription)
            this._itemsSubscription.unsubscribe();
    }

    Add(){
        //modelData: ModelData = new ModelData();
        
        this.modalService.ShowModal(-1, this._modelData, this.ParentProperty, false, this.Parameters)
            .result
                .then((response: T) => {
                    //this.Items.push(response);
                    //this.value = response.ID;
                    this.OnItemAdded(response);
                },
                    (reason) => {});
    }

    OnItemAdded(item){
    }

    Edit(id: number){
        this.modalService.ShowModal(id, this._modelData, null, false)
            .result
                .then((response: T) => {
                    this.OnItemEdited(response);
                },
                (reson) => {});
    }

    OnItemEdited(item){

    }

    Clear(){
        this.value = null;
    }

    setDisabledState(isDisabled: boolean){
        super.setDisabledState(isDisabled);
        if (this.selectControl){
            this.selectControl.nativeElement.disabled = isDisabled;
            this.dropDownControlButtons.isDisabled = isDisabled;
        }
        else
            this.multiSelect.disabled = isDisabled;

        this.changeDetectorRef.markForCheck();
    }

    //addPlaceholder(){
        //if(this.Placeholder && this.Placeholder.length > 0) {
            //let placeholder: T = <T>{};
            //placeholder.ID = -99;
            //placeholder[this.ModelProperty.indexOf(',') > 0 ? this.ModelProperty.substring(0, this.ModelProperty.indexOf(',')) : this.ModelProperty] = this.Placeholder;
            //this.Items.push(placeholder);
        //}
    //}

    focus(){
        // console.log('dropdown focus');
        let __this = this;
        setTimeout(function(){
            // __this.selectControl.nativeElement.focus();
            if (__this.selectControl && __this.selectControl.nativeElement) {
                __this.selectControl.nativeElement.focus();
              }
        }, 100)
    }

    loadItems(){
        // console.log('BaseDropdown: loadItems'+this.Label+'-ulaz-');
        if(this.ModelName && this.GetName){
            this.itemsLoading = true;
            
        if(this._itemsSubscription)
            this._itemsSubscription.unsubscribe();

        this._itemsSubscription = this.baseDataService.Get(this.ModelName, this.GetName, this.getParameters, this._modelData.MainList.ShortModelClass)
            .subscribe((data: T[]) => {
                // console.log('BaseDropdown: loadItems'+this.Label+'-izvr�en GET-');
                // console.log('BaseDropdown: loadItems'+this.Label+'-parametri za GET-'+new QueryParameter().GetParametersString(this.getParameters));
                this.Items = this.collectionService.SortItems(List(data), this.OrderBy, false);
                this.itemsLoading = false;
                // console.log('base-dropdown: loadItems'+this.GetName);
                this.itemsSubject.next(this.itemsSubject.value + 1);
                this.changeDetectorRef.markForCheck();
                this.itemsLoaded();
                //this.addPlaceholder();
            })
        }
    }

    itemsLoaded(){
    }
}